import { useI18n } from '../../i18n'
import { pressureColor } from '../../utils/operationalUx'
import entStyles from '../../styles/enterprise/EnterpriseOperationalUx.module.scss'
import styles from '../../styles/components/assets/AssetsRiskCompliance.module.scss'

type Props = {
  pressure?: string | null
  degraded?: boolean
  staleEvidence?: boolean
  runtimeWarning?: boolean
  unstableWorkflow?: boolean
  certificationRisk?: string | null
  compact?: boolean
}

export default function RiskComplianceOperationalIndicators({
  pressure,
  degraded,
  staleEvidence,
  runtimeWarning,
  unstableWorkflow,
  certificationRisk,
  compact,
}: Props) {
  const { t } = useI18n()
  const wrap = compact ? styles.rcIndicatorRowCompact : styles.rcIndicatorRow

  return (
    <div className={wrap}>
      {certificationRisk && ['AT_RISK', 'DEGRADED', 'CRITICAL', 'WATCH'].includes(certificationRisk) ? (
        <span className={`${styles.rcIndicatorChip} ${styles.rcIndicatorRisk}`} title={t('enterpriseOperationalUx.riskCompliance.certificationInstability', 'Certification instability')}>
          {certificationRisk}
        </span>
      ) : null}
      {pressure && pressure !== 'LOW' ? (
        <span
          className={entStyles.badgePressureHigh}
          style={{ color: pressureColor(pressure), borderColor: pressureColor(pressure), fontSize: '0.6875rem', padding: '0.15rem 0.4rem', borderRadius: 6, border: '1px solid' }}
          title={t('enterpriseOperationalUx.riskCompliance.runtimePressure', 'Runtime pressure')}
        >
          {pressure}
        </span>
      ) : null}
      {degraded ? (
        <span className={`${styles.rcIndicatorChip} ${styles.rcIndicatorDegraded}`} title={t('enterpriseOperationalUx.riskCompliance.degradedControl', 'Degraded control')}>
          {t('enterpriseOperationalUx.degradedShort', 'degraded')}
        </span>
      ) : null}
      {staleEvidence ? (
        <span className={`${styles.rcIndicatorChip} ${styles.rcIndicatorStale}`} title={t('enterpriseOperationalUx.staleEvidence', 'Stale evidence')}>
          {t('enterpriseOperationalUx.riskCompliance.staleShort', 'stale')}
        </span>
      ) : null}
      {unstableWorkflow ? (
        <span className={`${styles.rcIndicatorChip} ${styles.rcIndicatorWorkflow}`} title={t('enterpriseOperationalUx.riskCompliance.unstableWorkflow', 'Unstable workflow')}>
          {t('enterpriseOperationalUx.riskCompliance.workflowShort', 'workflow')}
        </span>
      ) : null}
      {runtimeWarning ? <span className={styles.rcRuntimeDot} aria-hidden title={t('enterpriseOperationalUx.riskCompliance.runtimeDegradation', 'Runtime degradation')} /> : null}
    </div>
  )
}
